import React, { useCallback, useContext, useEffect, useState } from 'react'
import './FolderPicker.css';
import Tree from './Tree/Tree';
import Actions, { FolderTemplate } from './Tree/ActionConst';
import { ResizableBox } from "react-resizable";
import "react-resizable/css/styles.css";
import { Col, Row } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft, faAngleRight, faArrowLeft, faArrowRight, faFileAlt, faFolder, faTimes } from '@fortawesome/free-solid-svg-icons';
import { Button, Modal, Spin } from 'antd'
import Config from '../../config.json'
import Draggable from 'react-draggable';
import axios from 'axios';
import { faArrowAltCircleLeft } from '@fortawesome/free-regular-svg-icons';
import AppContext from '../../Context/AppContext';
import { useSelector, useDispatch } from 'react-redux';
import { FolderPickerSelecetdPath, SelectedFiles } from '../../Context/ReduxContext';
import FILE_ICONS from './Tree/FileIcons';

export const WorkdriveFolderPicker = ({ value, uploading, setUploading, onChange, open, setOpen }) => {
    let [data, setData] = useState([]);
    const [path, setPath] = useState([]);
    const SelectedFile = useSelector((state) => state.AppReduxContext.SelectedFiles); // Read state
    const dispatch = useDispatch(); // Dispatch actions
    const [selectedObj, setSelectedObj] = useState();
    const [previewState, setPreviewState] = useState({ url: "", open: false });
    // const [uploading,setUploading] = useState(false);
    const [childs, setChilds] = useState([])
    const [loading, setLoading] = useState(false);
    const [modalPosition, setModalPosition] = useState({ x: 380, y: 100 });
    // const dispatchContext = useDispatch();
    useEffect(e => {
        setPath([]);
        dispatch(SelectedFiles({}));
        setSelectedObj(null);
    }, [open])
    useEffect(e => {
        
        if (selectedObj && selectedObj.prevUrl) {
            setPreviewState({ url: selectedObj.prevUrl, open: true });
        } else {
            setPreviewState({ url: "", open: false });
        }
    }, [selectedObj])
    const getFolderDataById = async (id, isChild) => {
        if (isChild) {
            setLoading(true);
        }
        var config = {
            Type: "Get",
            url: `https://www.zohoapis.com/workdrive/api/v1/files/${id}/files`,
            method: "GET",
            headers: {
                'Authorization': localStorage.getItem('token')
            }
        };

        await axios.post(Config.backend_aws_server_url + "zoho/workdrive", { config: config })
            .then(async function (response) {
                
                let Allfolders = response.data.data;
                let arr = [];
                for (let folder of Allfolders) {
                    let obj = {
                        "type": folder.attributes.type,
                        "id": folder.id,
                        "readOnly": true,
                        "name": folder.attributes.name,
                        "prevUrl": folder.attributes.thumbnail_url,
                        "files": []
                    }
                    arr.push(obj);
                }
                if (isChild) {
                    setChilds(arr);
                } else {
                    setData(arr);
                }

            }).catch(function (error) {
                console.log(error);
            }).finally(e => {
                setLoading(false);
            });


    }
    useEffect(e => {
        getFolderDataById("4snndf1add4f710e14016ba6eb3d69bacb086");
    }, [])
    useEffect(k => {
        
        setSelectedObj(value);
    }, [value])
    useEffect(e => {
        let temp = [...path]
        let thisFolder = temp.pop();
        if (thisFolder) {
            if (thisFolder.type == "folder") {
                getFolderDataById(thisFolder.id, true);
            }
        } else {
            setChilds([])
        }
        dispatch(FolderPickerSelecetdPath(path?.map(k => k.id)))
    }, [path])
    const handleClick = (props, flushPath) => {
        
        delete props["state"];
        if (props?.id) {
            let temp = [...(flushPath ? [] : path)]
            temp.push(props);
            setPath(temp);
            // getFolderDataById(props.id,true);
        } else {
            setChilds([])
        }
        setSelectedObj(props);
    };
    const handleDrag = (e, ui) => {
        
        if (e.target && e.target.closest(".ant-picker-dropdown")) {
            e.stopPropagation();
            return
        }
        const { x, y } = ui;
        setModalPosition({ x, y });
    };
    const getChildData = useCallback(data => {
        if (loading) {
            return <span style={{
                height: "100%",
                display: "flex",
                width: "100%",
                alignItems: "center",
                justifyContent: "center",
                // opacity: "0.2",
                cursor: "default"
            }}>
                <Spin></Spin>
            </span>
        } else if (childs?.length > 0) {
            return <div>
                <Tree
                    // selectedFile={selectedObj}
                    actionsAllowed={[]}
                    // maxChiledAllow={1}
                    data={childs}
                    onUpload={(data) => {
                        
                    }}
                    // onUpdate={(d) => onChange(d)}
                    onNodeClick={(props) => handleClick(props)}
                />
            </div>
        } else {
            return <span style={{
                height: "100%",
                display: "flex",
                width: "100%",
                alignItems: "center",
                justifyContent: "center",
                opacity: "0.2",
                cursor: "default"
            }}>
                <FontAwesomeIcon className='mr-1' size='lg' icon={faFileAlt} />
                <span>No data to show</span>
            </span>
        }
    }, [loading, childs])
    const onBack = () => {
        dispatch(SelectedFiles({}));
        let temp = [...path]
        temp.pop();
        setPath(temp);
    }
    const onClickBreadcrum = (item,index) => {
        
        if(path.length-1==index){
            return;
        }
        let temp = [...path];
        temp = temp.splice(0,index+1)
        setPath(temp);
        setSelectedObj(null);
    }
    const getIcon = useCallback(data => {
        return previewState.open ? <FontAwesomeIcon icon={faAngleRight} /> : <FontAwesomeIcon icon={faAngleLeft} />
    }, [previewState])
    return (
        <Modal

            open={open}
            className='Folder-Picker-Modal'
            onClose={e => {
                setPath([])
                setOpen(false);
            }}
            title={
                <div className='Draggable-component' style={{ display: "flex", color: "#5b6c97", justifyContent: "space-between", alignItems: "center" }}>
                    <span><FontAwesomeIcon color='#f5c72f' className='mr-1' icon={faFolder} /> Folder Explorer</span>
                    <span>
                        {Object.keys(SelectedFile)?.length > 0 && <Button onClick={e => {
                            dispatch(SelectedFile({}))
                            // setOpen(false)
                        }} className='mr-1'>Clear</Button>}
                        {Object.keys(SelectedFile)?.length > 0 && <Button onClick={e => {
                            onChange && onChange({ ...SelectedFile });
                        }} className='mr-1' type="primary">Upload</Button>}
                        <Button onClick={e => setOpen(false)} icon={<FontAwesomeIcon icon={faTimes} />}></Button>
                    </span>
                </div>
            }
            onCancel={e => {
                setPath([]);
                setOpen(false);
            }}

            closeIcon={<></>}
            destroyOnClose
            modalRender={(modal) => (
                <Draggable
                    handle=".Draggable-component"
                    defaultPosition={modalPosition}
                    position={{ x: modalPosition.x, y: modalPosition.y }}
                    onStop={handleDrag}
                >
                    <div>{modal}</div>
                </Draggable>
            )}
        >
            {uploading && <div style={{ position: "absolute", alignItems: "center", justifyContent: "center", zIndex: "10", display: "flex", height: "100%", width: "100%" }}>
                <Spin tip="Uploading">
                    <div style={{ display: "fglex", width: "10rem" }}></div>
                </Spin>
            </div>}
            <Row className='p0m0 Sub-Header' style={{ height: "5%" }} sm={12}>
                <div style={{
                    display: "flex",
                    "align-items": "center",
                    "color": "#5b6c97",
                    "font-weight": "700",
                }}>
                    <span>{path?.length > 0 && <FontAwesomeIcon className='mr-2 ml-2' icon={faArrowAltCircleLeft} onClick={onBack} />}</span>
                    <span>{path?.length > 0 && path.map((p,index)=><><span className='ml-2 mr-2'><FontAwesomeIcon icon={faAngleLeft}/></span><span style={path?.length-1!=index?{color:"#afb6c8"}:{}}><a onClick={e=>onClickBreadcrum(p,index)}>{p.name}</a></span></> )}</span>
                </div>
            </Row>
            <Row className='p0m0' style={{ height: "95%" }} sm={12}>
                <ResizableBox
                    width={300}
                    // height={100%}
                    style={{ height: "100%" }}
                    axis="x"
                    minConstraints={[300, Infinity]}
                    maxConstraints={[600, Infinity]}
                    resizeHandles={["e"]}
                >
                    <div style={{ height: "100%", overflow: "scroll" }}>
                        <Tree
                            selectedFile={selectedObj}
                            actionsAllowed={[]}
                            // maxChiledAllow={1}
                            data={data}
                            // onUpdate={(d) => onChange(d)}
                            onNodeClick={(props) => handleClick(props, true)}
                        />
                    </div>
                </ResizableBox>

                {/* Right Panel */}
                <div style={{ flex: 1, height: "100%", overflow: "scroll", backgroundColor: "rgb(255 255 255)" }}>
                    {getChildData()}
                    {previewState && previewState.url && <div className='File-Preview-Component'
                        style={previewState && previewState.url ? { width: previewState.open ? "37%" : "1%" } : {}}
                        onClick={e => {
                            let k = { ...previewState };
                            if (k && k?.open) {
                                k.open = false;
                            } else if (k && !k.open) {
                                k.open = true;
                            }
                            setPreviewState(k);
                        }}>
                        <div className='File-Preview-Component-Content'>
                            {previewState.open && <><span className='Preview-Header Elipsis-Class'>{selectedObj && FILE_ICONS[selectedObj?.type]}{selectedObj && selectedObj?.name}</span>
                                <img src={previewState.url} alt="" /> </>}
                        </div>
                        <div className='File-Preview-Component-Button'>
                            {getIcon()}
                        </div>
                    </div>}
                </div>
            </Row>

        </Modal>
    )
}
